import { Icon, type IconName } from '@web/components/ui/icons'
import type { ReactNode } from 'react'

/**
 * Flat screen header for phones: round icon buttons at the edges and the
 * title in the middle, matching the mobile client's TopBar so the chrome
 * stays out of the way and the content owns the screen.
 */
export function TopBar({
  title,
  subtitle,
  onBack,
  left,
  right,
  align = 'center',
}: {
  title: ReactNode
  subtitle?: ReactNode
  onBack?: () => void
  left?: ReactNode
  right?: ReactNode
  align?: 'center' | 'left'
}) {
  return (
    <header className={`m-topbar m-topbar-${align}`}>
      {onBack && (
        <CircleButton icon="chevronLeft" label="Back" onClick={onBack} />
      )}
      {left}
      <div className="m-topbar-copy">
        {typeof title === 'string' ? (
          <h1 className="m-topbar-title">{title}</h1>
        ) : (
          title
        )}
        {subtitle ? (
          typeof subtitle === 'string' ? (
            <div className="m-topbar-subtitle">{subtitle}</div>
          ) : (
            subtitle
          )
        ) : null}
      </div>
      {right}
    </header>
  )
}

/** The round tinted icon button the header, composer and sheets share. */
export function CircleButton({
  icon,
  label,
  onClick,
  disabled,
  tone = 'default',
  expanded,
  className = '',
  size,
}: {
  icon: IconName
  label: string
  onClick?: () => void
  disabled?: boolean
  tone?: 'default' | 'ghost' | 'accent' | 'danger'
  expanded?: boolean
  className?: string
  size?: number
}) {
  return (
    <button
      type="button"
      className={`m-circle m-circle-${tone} ${className}`}
      aria-label={label}
      title={label}
      aria-expanded={expanded}
      disabled={disabled}
      onClick={onClick}
    >
      <Icon name={icon} size={size ?? 17} />
    </button>
  )
}
